export const questionInitialQuery = {
  limit: 10,
  offset: 0,
  sort_column: "created_at",
  sort_direction: "DESC",
  search_term: "",
  category_id: "",
  selectedCategories: null,
  selectedAuthors: null,
  selectedChapters: null,
  selectedGrades: null,
  selectedDifficulties: null,
  selectedLanguages: null,
  selectedTypes: null,
  selectedTerms: null,
  selectedYears: null,
  selectedsubjects: null,
  selectedSources: null,
  selectedTeachers: null,
  selectedStartDate: null,
  selectedEndDate: null,
};

export const toArrayOrNull = (value) => {
  if (!value) return null;

  if (Array.isArray(value)) {
    const cleaned = value.filter(Boolean);
    return cleaned.length ? cleaned : null;
  }

  return [value];
};

export const formatQuestionCode = (questionId) =>
  questionId ? `QUSTN${questionId}` : "N/A";

export const mapQuestionToLibraryItem = (question, metaHelpers = {}) => {
  const {
    getCategoryName = () => "N/A",
    getTypeName = () => "N/A",
    getDifficultyName = () => "N/A",
    getSubjectName = () => "N/A",
    getGradeName = () => "N/A",
    getLanguageName = () => "N/A",
    getAuthorName = () => "N/A",
    getSourceName = () => "N/A",
    getYearName = () => "N/A",
    getTermName = () => "N/A",
    getChapterName = () => "N/A",
  } = metaHelpers;

  return {
    ...question,

    id: String(question.question_id),
    question_id: question.question_id,

    code: formatQuestionCode(question.question_id),
    name: question.title || "Untitled Question",
    createdAt: question.created_at,

    sub_questions: question.sub_questions || null,
    subQuestionCount: question.sub_questions
      ? String(question.sub_questions)
        .split(",")
        .map((id) => id.trim())
        .filter(Boolean).length
      : 0,

    owner: getCategoryName(question.category_id),
    type: getTypeName(question.qtype),
    difficulty: getDifficultyName(question.difficulty_id),

    subject: getSubjectName(question.subject_id),
    grade: getGradeName(question.grade_id),
    language: getLanguageName(question.language_id),
    author: getAuthorName(question.author_id),
    source: getSourceName(question.source_id),
    year: getYearName(question.year_id),
    term: getTermName(question.term_id),
    chapter: getChapterName(question.chapter_id),
    createdBy:
      [question.first_name, question.last_name].filter(Boolean).join(" ") ||
      question.created_by ||
      "N/A",
    raw: question,
  };
};

export const buildQuestionFilterQuery = (
  filters,
  currentQuery = questionInitialQuery
) => {
  const sortByValue = {
    "created-desc": { sort_column: "created_at", sort_direction: "DESC" },
    "created-asc": { sort_column: "created_at", sort_direction: "ASC" },
    title: { sort_column: "title", sort_direction: "ASC" },
  };

  const sortQuery = filters.sort?.includes(":")
    ? (() => {
      const [sort_column, sort_direction] = filters.sort.split(":");

      return {
        sort_column,
        sort_direction: sort_direction || "ASC",
      };
    })()
    : sortByValue[filters.sort] || sortByValue["created-desc"];

  return {
    ...questionInitialQuery,
    ...currentQuery,
    ...sortQuery,
    offset: 0,
    search_term: filters.search || "",
    selectedGrades: toArrayOrNull(filters.grade),
    selectedLanguages: toArrayOrNull(filters.language),
    selectedsubjects: toArrayOrNull(filters.subject),
    selectedTerms: toArrayOrNull(filters.term),
    selectedAuthors: toArrayOrNull(filters.author),
    selectedChapters: toArrayOrNull(filters.chapter),
    selectedDifficulties: toArrayOrNull(filters.difficulty),
    selectedSources: toArrayOrNull(filters.source),
    selectedTeachers: toArrayOrNull(filters.createdBy),
    selectedYears: toArrayOrNull(filters.year),
    selectedCategories: toArrayOrNull(filters.category),
    selectedTypes: toArrayOrNull(filters.type),
    selectedStartDate: filters.startDate || null,
    selectedEndDate: filters.endDate || null,
  };
};
